import React, {useMemo} from "react";
import {Box, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import Dialog from "../../../components/base/dialog";
import Button from "../../../components/base/button/button";
import PartFormComplianceCard from "./part-form-compliance-card";
import {mergePartFormComplianceForms} from "../utils/merge-part-form-compliance-forms";

const PartFormComplianceDialog = ({
    open,
    onClose,
    entries,
    onQualificationRefresh,
    loading = false,
}) => {
    const {t} = useTranslation("dialogs", {keyPrefix: "partFormComplianceDialog"});

    const mergedForms = useMemo(
        () => mergePartFormComplianceForms(entries),
        [entries],
    );

    const showPartLabels = (entries?.length ?? 0) > 1;

    return (
        <Dialog
            open={open}
            setOpen={(v) => !v && onClose()}
            maxWidth="sm"
            fullWidth
            scroll="paper"
            className="bound-dialog part-form-compliance-dialog"
            loading={loading}
        >
            <DialogTitle fontWeight={600} component="div">
                <Typography variant="h6" fontWeight={600} sx={{padding: 2}}>
                    {t("title")}
                </Typography>
            </DialogTitle>
            <DialogContent dividers>
                <Box sx={{padding: 2}}>
                    <PartFormComplianceCard
                        forms={mergedForms}
                        showPartLabels={showPartLabels}
                        onQualificationRefresh={onQualificationRefresh}
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{display: "flex", justifyContent: "space-between"}}>
                <Button variant="dialog" color="primary" onClick={onClose} borderRadius="0 8px 0 0">
                    {t("close")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PartFormComplianceDialog;
